import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const RotateLeftIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11L6.09 11C6.23 10.13 6.58 9.28 7.11 8.53ZM6.09 13L4.07 13C4.24 14.39 4.79 15.73 5.69 16.89L7.1 15.47C6.58 14.72 6.23 13.88 6.09 13ZM7.1 18.32C8.26 19.22 9.61 19.76 11 19.93L11 17.9C10.13 17.75 9.29 17.41 8.54 16.87L7.1 18.32ZM13 4.07L13 1L8.45 5.55L13 10L13 6.09C15.84 6.57 18 9.03 18 12S15.84 17.43 13 17.91L13 19.93C16.95 19.44 20 16.08 20 12S16.95 4.56 13 4.07Z"
      fill="currentColor"
    />
  </svg>
);

RotateLeftIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(RotateLeftIcon);
